import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/BaitSuccessNew.svg';

const BaitSuccess: React.FC = () => {
  return <img src={Icon} height={22} alt="Bait Success Icon" />;
};

export default BaitSuccess;
